import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import {
  INamedMeasuresQueryQuery,
  INamedMeasuresQueryQueryVariables,
  SearchNamedMeasureOption,
} from '../../../../utils/apollo/graphqlSchema';
import { queryMeasureSetNamedMeasure } from '../../../../redux/slices/oldBuilder';
import { GET_NAMED_MEASURES } from '../../../../utils/apollo/measures';
import { useAppDispatch } from '../../../../redux/hooks';
import {
  useDataFromSearchParams,
  SearchParamsDataSharingEnum,
} from '../../../../utils/searchParamsDataSharing';
import { assertNotNil } from '../../../../utils/types';

export default () => {
  const dispatch = useAppDispatch();

  const [searchParams, setSearchParams] = useSearchParams();

  const namedMeasureFromSearchParams = useDataFromSearchParams(searchParams);
  const namedMeasureData =
    namedMeasureFromSearchParams &&
    namedMeasureFromSearchParams.type ===
      SearchParamsDataSharingEnum.NamedMeasure
      ? namedMeasureFromSearchParams
      : null;

  const populateNamedMeasure = ({
    namedMeasures,
  }: INamedMeasuresQueryQuery) => {
    const entities = namedMeasures?.entities;

    if (entities?.length && namedMeasureData) {
      const measure = entities.find(
        (e) => e.id === namedMeasureData.namedMeasureId,
      );
      // XXX it was requested via include param
      assertNotNil(measure);

      // populate builder measures with cached measure
      dispatch(queryMeasureSetNamedMeasure({ measure }));

      // reset search params
      setSearchParams('', { replace: true });
    }
  };

  const [loadNamedMeasures] = useLazyQuery<
    INamedMeasuresQueryQuery,
    INamedMeasuresQueryQueryVariables
  >(GET_NAMED_MEASURES, {
    onCompleted: populateNamedMeasure,
  });

  useEffect(() => {
    if (namedMeasureData) {
      const { namedMeasureId, schemaId } = namedMeasureData;

      loadNamedMeasures({
        variables: {
          schemaId,
          includeIds: [namedMeasureId],
          term: '',
          searchNamedMeasureOption: SearchNamedMeasureOption.All,
          pagination: {
            first: 1,
            after: 0,
          },
        },
      });
    }
  }, [loadNamedMeasures, namedMeasureData]);
};
